import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { Destination } from '../types';
import { ByIdStructure, ModelOptions } from '../../../types';

interface Context<T> {
    get: (params?: Partial<T>, options?: ModelOptions, updateState?: boolean) => Promise<Array<T>>;
    getById: (id: string, params?: Partial<T>) => Promise<T>;
    getSchema: () => Promise<any>;
    schema: {};
    post: (body: Partial<T>, updateState?: boolean, last?: boolean) => Promise<T>;
    put: (body: Partial<T>) => Promise<T>;
    data: ByIdStructure<T>;
    setData: (a: any) => void;
    selected: T | null | {};
    setSelected: (a: T) => void;
    remove: (id: string) => Promise<string>;
    error: T | null | {};
    softDelete: (body: { _id: string }) => Promise<any>;
}

const DestinationsContext = createContext<Context<Destination>>({
    get: api.get,
    getById: api.getById,
    getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: { ids: [], byId: {} },
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    error: null,
    softDelete: api.softDelete
});
export default DestinationsContext;
